import type { Action, AnyAction, Dispatch } from '@reduxjs/toolkit';
import {
  putClientOnboardingSlideProgressByClientIdResponse,
  putClientByClientIdResponse,
  deleteClientByClientIdResponse,
  putClientPartnerLinkForClientByClientIdResponse,
  putClientRelationshipStageByClientIdResponse,
  putClientReferralSourceByClientIdResponse,
} from './clientModel';
import { postBatchClientEngagementEmailsResponse } from './advisorOpportunitiesModel';
import { AppState } from './store';
import { createSimpleMiddleware } from './createSimpleMiddleware';
import {
  fetchClientsForAdvisorByAdvisorIdRequest,
  postAdvisorNewClientResponse,
  postAdvisorNewDuplicateClientResponse,
} from './clientsModel';
import { isNullOrUndefined } from '@shared/isNullOrUndefined';
import {
  postBatchIntakeFormEmailResponse,
  postIntakeFormEmailResponse,
} from './clientEmailModel';
import {
  postAdvisorUpdatesByAdvisorIdResponse,
  putAdvisorReferralSourceByAdvisorIdResponse,
} from './advisorModel';

/**
 * Middleware to invalidate & refetch clients list when a client is updated from the advisor dashboard
 */
function invalidateClientsMiddleWareImpl(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
  next: Dispatch<AnyAction>,
  action: Action<string>,
) {
  next(action);

  if (
    action.type === putClientOnboardingSlideProgressByClientIdResponse.type ||
    action.type === putClientByClientIdResponse.type ||
    action.type === deleteClientByClientIdResponse.type ||
    action.type === putClientPartnerLinkForClientByClientIdResponse.type ||
    action.type === postAdvisorNewClientResponse.type ||
    action.type === postAdvisorNewDuplicateClientResponse.type ||
    action.type === postBatchClientEngagementEmailsResponse.type ||
    action.type === postIntakeFormEmailResponse.type ||
    action.type === putClientRelationshipStageByClientIdResponse.type ||
    action.type === putClientReferralSourceByClientIdResponse.type ||
    action.type === putAdvisorReferralSourceByAdvisorIdResponse.type ||
    action.type === postBatchIntakeFormEmailResponse.type ||
    action.type === postAdvisorUpdatesByAdvisorIdResponse.type
  ) {
    setTimeout(() => fetchNewClients(dispatch, getStore));
  }
}

export const invalidateClientsMiddleWare = createSimpleMiddleware(
  invalidateClientsMiddleWareImpl,
);

export function fetchNewClients(
  dispatch: Dispatch<AnyAction>,
  getStore: () => AppState,
) {
  const advisor = getStore().session.advisor;
  if (isNullOrUndefined(advisor?.advisorId)) {
    return;
  }
  dispatch(
    fetchClientsForAdvisorByAdvisorIdRequest({
      advisorId: advisor!.advisorId,
      isInvalidation: true,
    }),
  );
}
